<template>
  <div :class="joinClasses('user-accordion', modifiers)">
    <div
      class="user-accordion__header"
      @click="toggleAccordion"
    >
      <div :class="classes">
        <AccordionArrowSVG />
        <slot name="header-main" />
      </div>
      <slot name="header-right" />
    </div>
    <div
      v-if="accordionIsOpen"
      class="user-accordion__content"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';

import joinClasses from '@/functions/join_classes';

import AccordionArrowSVG from '@/images/accordion-arrow.svg';

const props = defineProps({
  active: { type: Boolean, required: false, default: null },
  genericHeader: { type: Boolean, required: false, default: null },
  modifiers: { type: Array, default: () => [] },
});

const accordionIsOpen = ref(null);

const classes = computed(() => ({
  'user-accordion__header-title': true,
  'user-accordion__header-title-generic': props.genericHeader,
  'user-accordion__header--active': accordionIsOpen.value,
}));

onMounted(() => {
  accordionIsOpen.value = props.active;
});

function toggleAccordion() {
  accordionIsOpen.value = !accordionIsOpen.value;
}
</script>

<style lang="scss" scoped>
@import '@/stylesheets/global';

$transition-speed: 0.1s;

.user-accordion {
  $block: &;

  &__header {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    padding: bu(1);

    svg {
      transition: $transition-speed;
    }

    &:hover {
      background-color: map-get($background-color, light);
      border-radius: map-get($border-radius, medium);
    }

    &--active {
      svg {
        transform: rotate(90deg);
        transition: $transition-speed;
      }
    }
  }

  &__header-title {
    align-items: center;
    display: flex;

    svg {
      margin-right: bu(2);
    }
  }

  &__header-title-generic {
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;

    svg {
      margin-right: 0;
    }
  }

  &__content {
    padding: 0 bu(1) bu(1) bu(2.55);
  }

  &--flat {
    #{$block}__header,
    #{$block}__content {
      padding: 0;
    }
  }

  &--full-width-header {
    #{$block}__header-title {
      width: 100%;
    }
  }
}
</style>
